<div class="modal-header" id="material-inventory-modal-title">
    <h3 class="modal-title" id="modal-title" translate="MATERIAL_INVENTORY_CSE_STOCK_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form>
        <fieldset *ngIf="!isLoading">
            <div class="row mb-3">
                <label
                    class="col-2 col-form-label"
                    for="materialNumber"
                    translate="MATERIAL_INVENTORY_CSE_STOCK_MATERIAL_NUMBER_LABEL"
                ></label>
                <div class="col-3">
                    <pace-core-text-input
                        id="materialNumber"
                        [(model)]="model.materialNumber"
                        [ariaLabel]="'MATERIAL_INVENTORY_CSE_STOCK_MATERIAL_NUMBER_LABEL' | translate"
                    ></pace-core-text-input>
                </div>
                <label
                    class="col-3 col-form-label"
                    for="materialDescription"
                    translate="MATERIAL_INVENTORY_CSE_STOCK_MATERIAL_DESCRIPTION_LABEL"
                ></label>
                <div class="col-3">
                    <pace-core-text-input
                        id="materialDescription"
                        [(model)]="model.materialDescription"
                        [ariaLabel]="'MATERIAL_INVENTORY_CSE_STOCK_MATERIAL_DESCRIPTION_LABEL' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
            <div class="col-12">
                <table class="table">
                    <thead>
                        <tr>
                            <th translate="MATERIAL_INVENTORY_CSE_STOCK_MATERIAL_NUMBER"></th>
                            <th translate="MATERIAL_INVENTORY_CSE_STOCK_MATERIAL_DESCRIPTION"></th>
                            <th translate="MATERIAL_INVENTORY_CSE_STOCK_NOTIFICATION_NUMBER"></th>
                            <th translate="MATERIAL_INVENTORY_CSE_STOCK_BATCH_ID"></th>
                            <th translate="MATERIAL_INVENTORY_CSE_STOCK_ORDER_NUMBER"></th>
                            <th translate="MATERIAL_INVENTORY_CSE_STOCK_STORAGE_LOCATION"></th>
                            <th translate="MATERIAL_INVENTORY_CSE_STOCK_QUANTITY"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            *ngFor="
                                let material of model.materialInventoryList
                                    | filter: { materialNumber: model.materialNumber.value }
                                    | filter: { description: model.materialDescription.value }
                            "
                        >
                            <td class="form-control-static">{{ material.materialNumber }}</td>
                            <td class="form-control-static">{{ material.description }}</td>
                            <td class="form-control-static">{{ material.notificationNumber }}</td>
                            <td class="form-control-static">{{ material.batchNumber }}</td>
                            <td class="form-control-static">{{ material.poNumber }}</td>
                            <td class="form-control-static">{{ material.storageLocation }}</td>
                            <td class="form-control-static">{{ material.quantity }}</td>
                        </tr>
                        <tr class="noStockLabel" *ngIf="model.materialInventoryList.length === 0">
                            <td colspan="6" translate="MATERIAL_INVENTORY_CSE_STOCK_NO_CSE_STOCK_AVAILABLE"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </fieldset>
    </form>
    <progressbar *ngIf="isLoading" [value]="100" [striped]="true" type="default">{{
        'MATERIAL_INVENTORY_CSE_STOCK_LOADING' | translate
    }}</progressbar>
</div>
